import moment from 'moment-timezone'

export default (greatest, least) => (value) => {
  if (value) {
    if (least) {
      if (moment(value).isAfter(moment(least).endOf('day'))) {
        return false
      }
    }
    if (greatest) {
      if (moment(value).isBefore(moment(greatest).startOf('day'))) {
        return false
      }
    }
  }
  return true
}
